import { z } from 'zod';
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["ADD_AND_BUY"] = "add_and_buy";
    FeatureFlag["APPLE_PAY"] = "apple_pay";
    FeatureFlag["BUTTON_NEW_TEXT"] = "button_new_text";
    FeatureFlag["BUTTON_PRICE_STRIKETHROUGH"] = "button_price_strikethrough";
    FeatureFlag["BUTTON_WIDGET_LEAD_TIME_DELIVERY"] = "button_widget_lead_time_delivery";
    FeatureFlag["CLICK_N_COLLECT"] = "click_n_collect";
    FeatureFlag["DRAFT_ORDER_SHIPPING_RATE"] = "draft_order_shipping_rate";
    FeatureFlag["GDPR_ACCOUNT_MANAGER"] = "gdpr_account_manager";
    FeatureFlag["GDPR_MARKETING_MANAGER"] = "gdpr_marketing_manager";
    FeatureFlag["GOOGLE_PAY"] = "google_pay";
    FeatureFlag["HIDE_DISCOUNT_INPUT"] = "hide_discount_input";
    FeatureFlag["JUST_BUTTON"] = "button";
    FeatureFlag["NOTE_FROM_MERCHANT"] = "note_from_merchant";
    FeatureFlag["PRE_PURCHASE_PICKUP"] = "pre_purchase_pickup";
    FeatureFlag["PRODUCT_STOCK_INDICATOR"] = "product_stock_indicator";
    FeatureFlag["QUANTITY_SELECTOR"] = "quantity_selector";
    FeatureFlag["RECOMMENDED_DISCOUNTS"] = "recommended_discounts";
    FeatureFlag["SHOPIFY_GIFT_CARD"] = "shopify_gift_card";
    FeatureFlag["SHOW_MOBILE_BACKGROUND_IMAGE"] = "show_mobile_background_image";
    FeatureFlag["SMART_UPSELL"] = "smart_upsell";
    FeatureFlag["UPSELL"] = "upsell";
})(FeatureFlag || (FeatureFlag = {}));
export const ZFeatureFlag = z.enum(FeatureFlag);
export const FEATURE_FLAG_DEFINITIONS = {
    [FeatureFlag.ADD_AND_BUY]: {
        type: 'button',
        name: FeatureFlag.ADD_AND_BUY,
        description: 'Enable Add to Cart and Buy functionality',
    },
    [FeatureFlag.APPLE_PAY]: {
        type: 'payment_methods',
        name: FeatureFlag.APPLE_PAY,
        description: 'Enable Apple Pay as a payment method',
    },
    [FeatureFlag.BUTTON_NEW_TEXT]: {
        type: 'button',
        name: FeatureFlag.BUTTON_NEW_TEXT,
        description: 'Use "Buy now" text on the checkout button',
    },
    [FeatureFlag.BUTTON_PRICE_STRIKETHROUGH]: {
        type: 'button',
        name: FeatureFlag.BUTTON_PRICE_STRIKETHROUGH,
        description: 'Show discount prices with strikethrough',
    },
    [FeatureFlag.BUTTON_WIDGET_LEAD_TIME_DELIVERY]: {
        type: 'delivery',
        name: FeatureFlag.BUTTON_WIDGET_LEAD_TIME_DELIVERY,
        description: 'Show delivery time on the button and/or under the button on the website',
    },
    [FeatureFlag.CLICK_N_COLLECT]: {
        type: 'delivery',
        name: FeatureFlag.CLICK_N_COLLECT,
        description: 'Enable click and collect option in checkout. Requires Carrier Service enablement on shipping integration settings page.',
    },
    [FeatureFlag.DRAFT_ORDER_SHIPPING_RATE]: {
        type: 'checkout',
        name: FeatureFlag.DRAFT_ORDER_SHIPPING_RATE,
        description: 'Use shipping rate handle in draft orders to preserve carrier codes',
    },
    [FeatureFlag.GDPR_ACCOUNT_MANAGER]: {
        type: 'checkout',
        name: FeatureFlag.GDPR_ACCOUNT_MANAGER,
        description: 'Enable GDPR compliant account management',
    },
    [FeatureFlag.GDPR_MARKETING_MANAGER]: {
        type: 'checkout',
        name: FeatureFlag.GDPR_MARKETING_MANAGER,
        description: 'Enable GDPR compliant marketing preferences',
    },
    [FeatureFlag.GOOGLE_PAY]: {
        type: 'payment_methods',
        name: FeatureFlag.GOOGLE_PAY,
        description: 'Enable Google Pay as a payment method',
    },
    [FeatureFlag.HIDE_DISCOUNT_INPUT]: {
        type: 'discount',
        name: FeatureFlag.HIDE_DISCOUNT_INPUT,
        description: 'Hide discount code input field',
    },
    [FeatureFlag.JUST_BUTTON]: {
        type: 'button',
        name: FeatureFlag.JUST_BUTTON,
        description: 'Enable the Just checkout button on product pages',
    },
    [FeatureFlag.NOTE_FROM_MERCHANT]: {
        type: 'checkout',
        name: FeatureFlag.NOTE_FROM_MERCHANT,
        description: 'Display merchant notes during checkout',
    },
    [FeatureFlag.PRE_PURCHASE_PICKUP]: {
        type: 'delivery',
        name: FeatureFlag.PRE_PURCHASE_PICKUP,
        description: 'Enable pickup options before purchase',
    },
    [FeatureFlag.PRODUCT_STOCK_INDICATOR]: {
        type: 'checkout',
        name: FeatureFlag.PRODUCT_STOCK_INDICATOR,
        description: 'Display remaining stock information',
    },
    [FeatureFlag.QUANTITY_SELECTOR]: {
        type: 'checkout',
        name: FeatureFlag.QUANTITY_SELECTOR,
        description: 'Allow customers to select quantity before checkout',
    },
    [FeatureFlag.RECOMMENDED_DISCOUNTS]: {
        type: 'discount',
        name: FeatureFlag.RECOMMENDED_DISCOUNTS,
        description: 'Show recommended discount codes',
    },
    [FeatureFlag.SHOPIFY_GIFT_CARD]: {
        type: 'payment_methods',
        name: FeatureFlag.SHOPIFY_GIFT_CARD,
        description: 'Accept Shopify gift cards',
    },
    [FeatureFlag.SHOW_MOBILE_BACKGROUND_IMAGE]: {
        type: 'checkout_design',
        name: FeatureFlag.SHOW_MOBILE_BACKGROUND_IMAGE,
        description: 'Display background image on mobile',
    },
    [FeatureFlag.SMART_UPSELL]: {
        type: 'checkout',
        name: FeatureFlag.SMART_UPSELL,
        description: 'Add visited products to the upsell module (only works with analytics app)',
    },
    [FeatureFlag.UPSELL]: {
        type: 'checkout',
        name: FeatureFlag.UPSELL,
        description: 'Show upsell offers after purchase',
    },
};
//# sourceMappingURL=index.js.map